
/* styles */
require("!!vue-style-loader!css-loader?minimize!../../../node_modules/vue-loader/lib/style-rewriter?id=data-v-4e49e224&scoped=true!../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./NewCategory.vue")

var Component = require("!../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../node_modules/vue-loader/lib/selector?type=script&index=0!./NewCategory.vue"),
  /* template */
  require("!!../../../node_modules/vue-loader/lib/template-compiler?id=data-v-4e49e224!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./NewCategory.vue"),
  /* scopeId */
  "data-v-4e49e224",
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./dev/src/components/NewCategory.vue
// module id = ./dev/src/components/NewCategory.vue
// module chunks = 0